export default __webpack_public_path__ + "static/media/gpt.3efeb0fe.png";